import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Profile } from '@classes/profiles/profile';
import { environment } from '@environments/environment';
import { ReducedProfile } from '@interfaces/profiles/reduced-profile';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProfileService {
    addProfileSubject = new Subject<Profile>();
    
    private readonly baseUrl = environment.apiUrl + 'profile';
    private readonly profilesSubject = new BehaviorSubject<Profile[]>([]);
    private readonly editedProfileSubject = new BehaviorSubject<Profile>(null);

    private readonly http = inject(HttpClient);

    constructor() { }

    get profiles$(): Observable<Profile[]> {
        return this.profilesSubject.asObservable();
    }

    get editedProfile$(): Observable<Profile> {
        return this.editedProfileSubject.asObservable();
    }

    set profiles(profiles: Profile[]) {
        this.profilesSubject.next(profiles);
    }

    set editedProfile(profile: Profile) {
        this.editedProfileSubject.next(profile);
    }

    get(): Observable<Profile[]> {
        return this.http.get<Profile[]>(this.baseUrl)
            .pipe(
                map((profilesFromApi: Profile[]) => this.profiles = profilesFromApi)
            );
    }

    post(profile: Profile): Observable<Profile> {
        return this.http.post<Profile>(this.baseUrl, profile);
    }

    put(profile: Profile): Observable<Profile> {
        return this.http.put<Profile>(this.baseUrl, profile);
    }

    putReports(profile: Profile): Observable<Profile> {
        return this.http.put<Profile>(`${this.baseUrl}/reports`, profile);
    }

    delete(profile: Profile): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${profile.id}`);
    }

    getUserProfiles(): Observable<ReducedProfile[]> {
        return this.http.get<ReducedProfile[]>(`${environment.apiUrl}user-profiles`);
    }

}
